import { push, replace, goBack } from 'react-router-redux';
import {
  PROMPT_MESSAGE,
  PROMPT_MESSAGE_RESET,
} from '../constants/actions';

export function promptMessage({ header, message, callback, icon, samePage }) {
  return {
    type: PROMPT_MESSAGE,
    payload: {
      header,
      message,
      callback,
      icon,
      samePage,
      show: true,
    },
  };
}

export function promptChangesMessage({ header, message, samePage, callback }) {
  return (dispatch) => {
    dispatch(promptMessage({ header: header || 'Unsaved changes', message, callback, icon: 'warning sign', samePage }));
  };
}

export function promptChangesLeave(nextLocation) {
  return (dispatch) => {
    switch (nextLocation.action) {
      case 'POP':
        dispatch(goBack());
        break;
      case 'REPLACE':
        dispatch(replace(nextLocation));
        break;
      default:
        dispatch(push(nextLocation));
    }
  };
}

export function resetPromptMessage() {
  return {
    type: PROMPT_MESSAGE_RESET,
  };
}



// WEBPACK FOOTER //
// ./src/actions/prompt.js